const jquery = $;

$.fn.extend({
  handleSelectFileManagerImage() {
    $('[data-modal-type="file_manager_frame"]').on('load', function () {
      $(this).contents().on('click', '.select', function () {
        const path = $(this).attr('data-path')

        $('[data-modal-type="path"]').val(path);
        $('[data-modal-type="image"]').attr('src', path).removeClass('hidden');
        $('[data-modal-type="icon"]').addClass('hidden');
        $('[data-action="remove-image"]').attr('disabled', false);
        $('[data-modal-type="file_manager"]').modal('hide');
      });
    });
  },

  handleRemoveFileManagerImage() {
    $('[data-action="remove-image"]').click(function () {
      $('[data-modal-type="path"]').val(null);
      $('[data-modal-type="image"]').attr('src', '').addClass('hidden');
      $('[data-modal-type="icon"]').removeClass('hidden');

      $(this).attr('disabled', true);
    })
  },

  handleOpenFileManagerModal() {
    $('[data-action="open-modal"]').click(function () {
      $('[data-modal-type="file_manager"]').modal('show');
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleSelectFileManagerImage();
  jquery(document).handleRemoveFileManagerImage();
  jquery(document).handleOpenFileManagerModal();
});
